

export const supabase_url = "https://sfkgqscbwofiphfxhnxg.supabase.co"
export const supabase_anon_key = "sb_publishable_XWsGRSpmju8qjodw4gIU8A_O_mHUR1H"
export const INTERACTABLES_FILES_BUCKET = "interactables_files"
const MAX_INTERACTABLE_MEGA_BYTES = 50
export const MAX_INTERACTABLE_SIZE = {
    MEGA_BYTES: MAX_INTERACTABLE_MEGA_BYTES,
    BYTES: MAX_INTERACTABLE_MEGA_BYTES * 1024 * 1024,
}
export const INTERACTABLE_FILE_SIGNED_URL_EXPIRY_SECONDS = 60 * 60 // 1 hour
// TODO: use this
export const MAX_TITLE_LENGTH = 200
